const API_BASE = "umbraco/api/KnowledgeHubArticles/Get";
const INITIAL_LOAD_COUNT = 15;
const LOAD_MORE_COUNT = 3;

const loadMoreBtn = document.getElementById("kh-load-more");
const articlesContainer = document.getElementById("kh-article-wrapper");
const $filterBtns = document.querySelectorAll(".js--kh-filter > button");

let isNetworkLoading = false;

if (!loadMoreBtn || !articlesContainer) return;

const validCategories = new Set(Array.from($filterBtns, btn => btn.innerText.trim().toLowerCase()));

function syncUIstate(totalCount) {
  articlesContainer.dataset.totalCount = totalCount;
  loadMoreBtn.disabled = totalCount <= articlesContainer.children.length;
}

async function updateArticles({ category = "all", isAppend = false } = {}) {
  try {
    const url = new URL(API_BASE, location.origin)
    url.searchParams.set("category", category);
    if (isAppend) {
      url.searchParams.set("skip", articlesContainer.children.length);
      url.searchParams.set("take", LOAD_MORE_COUNT);
    } else {
      url.searchParams.set("skip", 0);
      url.searchParams.set("take", INITIAL_LOAD_COUNT)
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`ERROR: ${response.status}. ${response?.message ?? ""}`)
    }
    const data = await response.json();
    if (!data || !("totalCount" in data) || !("result" in data)) {
      return;
    }
    const htmlString = data.result.map(renderArticleNode).join("");
    if (isAppend) {
      articlesContainer.insertAdjacentHTML("beforeend", htmlString);
    } else {
      articlesContainer.innerHTML = htmlString;
    }
    syncUIstate(data.totalCount ?? 0)

  } catch (error) {
    console.error("Failed handling article loading", error)
  }
}

function syncFilterButtonUI(selectedCategory) {
  $filterBtns.forEach(btn => {
    btn.ariaSelected = (btn.innerText.trim().toLowerCase() === selectedCategory.toLowerCase());
  });
}

function renderArticleNode({ title, description, category, pageUrl, mediaType, mediaUrl, mediaExtension }) {
  const mediaMarkup = (mediaType === "video")
    ? `<video class="aspect-[5/4] object-cover" controls autoplay loop muted>
          <source src="${mediaUrl}" type="video/${mediaExtension}" />
          <p>Your browser does not support video</p>
        </video>`
    : `<img src="${mediaUrl}"
            alt="${title}"
            class="aspect-[5/4] object-cover object-center"
            loading="lazy" />`;

  return `
  <article data-category="${category}" class="text-white relative contain-content" >
    ${mediaMarkup}
    <a href="${pageUrl}" class="after:content-[''] after:absolute after:inset-0"></a>
    <div class="pt-4 lg:pt-6 px-3 lg:px-4 space-y-3">
      <h3 class="text-pretty font-transducer font-bold -tracking-wider text-lg/[1.1] md:text-xl/[1.1] lg:text-2xl/[1.1]">${title}</h3>
      <p title="${description}" class="font-gibson text-xs/normal md:text-sm/normal lg:text-base/normal font-normal line-clamp-3 lg:lineclamp-2">${description}</p>
      <span class="px-2.5 py-1.5 text-white bg-balise-orange uppercase font-gibson text-xs/[1.1] lining-nums proportional-nums tracking-wider ">${category}</span>
    </div>
  </article>
  `;
}

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(location.search);
  const activeCategory = urlParams.get("category") ?? "all";

  if(activeCategory.toLowerCase() !== "all"){
    syncFilterButtonUI(activeCategory);
    updateArticles({ category: activeCategory, isAppend: false });
  }
});

$filterBtns.forEach(btn => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    const chosenCategory = btn.innerText.trim().toLowerCase();
    syncFilterButtonUI(chosenCategory);

    const url = new URL(location.href);
    url.searchParams.set("category", chosenCategory)
    history.pushState({}, "", url);

    updateArticles({ category: chosenCategory, isAppend: false });
  });
});

loadMoreBtn.addEventListener("click", (e) => {
  e.preventDefault();
  const urlParams = new URLSearchParams(location.search);
  const activeCategory = urlParams.get("category") ?? "all";

  updateArticles({ category: activeCategory, isAppend: true });
});